
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M511.85 476.754c-11.038-86.107-63.95-157.871-136.377-196.119-30.607 30.643-72.864 49.613-119.471 49.613-46.601 0-88.864-18.971-119.477-49.613C64.099 318.883 11.18 390.646.147 476.754c-.651 5.063.876 10.006 4.281 13.876 3.937 4.482 9.802 7.046 16.093 7.046h470.961c6.285 0 12.155-2.563 16.097-7.046 3.417-3.892 4.928-8.813 4.271-13.876zM149.88 262.015c2.743 2.881 5.617 5.632 8.586 8.295 25.952 23.234 60.074 37.482 97.536 37.482s71.584-14.27 97.536-37.482a153.49 153.49 0 008.586-8.295c2.736-2.884 5.398-5.836 7.917-8.933 20.323-25.196 32.577-57.192 32.577-92.027 0-80.914-65.779-146.731-146.616-146.731-80.838 0-146.617 65.828-146.617 146.731 0 34.835 12.248 66.831 32.578 92.027 2.502 3.097 5.168 6.039 7.917 8.933z"}})])
          )
        }
      }
    